var _defs, _path, _path2, _path3, _path4, _path5, _line, _path6, _path7, _line2, _path8, _path9, _polyline;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOverValidation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{fill:none;stroke:#1a242d;stroke-miterlimit:10;}.cls-1,.cls-3{stroke-width:0.9px;}.cls-2,.cls-4{stroke-width:0.5px;}.cls-3,.cls-4{stroke-linecap:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "_") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.84,15.91h3.91a2.83,2.83,0,0,1,2.83,2.83V20.2A1.62,1.62,0,0,1,15,21.82H8.68A1.62,1.62,0,0,1,7.06,20.2V18.69A2.78,2.78,0,0,1,9.84,15.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.59,21c0,.32,0-1.07,0,0,0,1.33-.15,2.41-.34,2.41s-.3-.85-.33-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.72,21.46c0,1.12-.16,2-.33,2S7.06,22.34,7.06,21v-.52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.26,17.92s1-1.19,1.8,0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.44,19.41H13.52a2.22,2.22,0,0,1-3.23,0H7.06"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 13.93,
    y1: 13.99,
    x2: 13.93,
    y2: 15.91
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.62,15.91V1.68a1,1,0,0,1,.94-1.1H13a1,1,0,0,1,.94,1.08V2.92"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.56,17.92s1-1.19,1.79,0"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 7.39,
    y1: 19.1,
    x2: 16.25,
    y2: 19.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.29,4.77V9.2a1.36,1.36,0,0,1-1.36,1.36H17.16A1.36,1.36,0,0,1,15.8,9.2V4.07a1.36,1.36,0,0,1,1.36-1.36H21A1.27,1.27,0,0,1,22.29,4V9.2a1.36,1.36,0,0,1-1.36,1.36h-.45a1.35,1.35,0,0,1-1.33,1.08H19a1.36,1.36,0,0,1-1.34,1.15H13.91a1.34,1.34,0,0,1-1.35-1.35V6.3a1.35,1.35,0,0,1,1.35-1.36H14a1.36,1.36,0,0,1,1.34-1.15h.45a1.35,1.35,0,0,1,1.33-1.08h3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19,11.64H15.52A1.48,1.48,0,0,1,14,10.16V4.94"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "17.67 7.47 18.5 8.32 20.98 5.23"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverValidation);
export default __webpack_public_path__ + "static/media/over_validation.ce289ed5ac9f93310351e3759483bf0f.svg";
export { ForwardRef as ReactComponent };